export default __webpack_public_path__ + "static/media/logoLine.180d1c5f.webp";